<template>
  <b-container fluid class="p-0" id="main_layout">
    <b-row no-gutters v-if="$mq == 'sm' || $mq == 'md'">
      <b-col style="padding-right: 0">
        <MobileTitle />
      </b-col>
    </b-row>

    <b-row no-gutters v-if="has_alert">
      <b-col>
        <b-alert show variant="danger" id="page_alert" class="mb-0">{{page_alert}}</b-alert>
      </b-col>
    </b-row>

    <b-row no-gutters style="flex-grow: 1; position: relative">
      <b-col cols=2 id="main_nav_container"
                    v-bind:class="$mq"
                    v-bind:style="{ width: nav_width,
                                position : nav_position,
                                   height: ($mq == 'sm' || $mq == 'md') ? '100%' : '' }">
        <MainNav v-bind:section="section"/>
      </b-col>

      <b-col v-bind:cols="main_content_cols"
             id="main_content_container"
             class="p-0"
             v-bind:style="{ 'max-width': content_max_width,
                             'filter': (($mq == 'sm' || $mq == 'md') && !nav_collapsed) ? 'blur(2px)' : ''}">
        <slot></slot>

        <div id="main_footer_container" v-if="!no_footer" :class="section">
          <MainFooter />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MobileTitle   from './MobileTitle.vue'
import MainNav       from './MainNav.vue'
import MainFooter    from './MainFooter.vue'

export default {
  name: 'MainLayout',

  components: {
    MobileTitle,
    MainNav,
    MainFooter
  },

  data : function(){
    return {page_alert : ''};
  },

  computed : {
    has_alert : function(){
      return this.page_alert != '';
    },

    nav_collapsed : function(){
      return this.$store.state.nav.collapsed;
    },

    nav_width : function(){
      return this.$store.state.nav.width;
    },

    content_max_width : function(){
      return this.$store.state.nav.content_max_width;
    },

    nav_position : function(){
      return (this.$mq == 'sm' || this.$mq == 'md') ? 'absolute' : '';
    },

    main_content_cols : function(){
      return this.$store.state.nav.content_cols;
    }
  },

  props : {
    section : String,
    no_footer : Boolean
  }
}
</script>

<style scoped>
#main_layout{
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

#page_alert{
  border-radius: 0;
}

#main_nav_container{
  flex-basis: auto;
  z-index: 1;
  padding-right: 0;
}

#main_content_container{
  flex-grow: 1;

  display: flex;
  flex-direction: column;
}

#main_footer_container{
  display: flex;
  justify-content: center;
  background: #eef1f6;
}

/* XXX */
#main_footer_container.source{
  background-color: white;
}
</style>
